import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoutes = ({ children, redirectTo, checkOnboarding = true }) => {
  const token = () => {
    const getToken = localStorage.getItem('AccessToken');
    return !!getToken ? true : false;
  };

  const isOnboardingCompleted = () => {
    if (!checkOnboarding) return true;
    
    try {
      const currentUser = JSON.parse(localStorage.getItem('CurrentUser') || '{}');
      const onboardingStatus = currentUser?.isOnboarding === true;
      return onboardingStatus;
    } catch (error) {
      console.error('Error parsing user data in ProtectedRoutes:', error);
      return false;
    }
  };

  // Check if user is authenticated
  if (!token()) {
    return <Navigate to={redirectTo} />;
  }

  // Check if onboarding is completed (only if checkOnboarding is true)
  if (checkOnboarding && !isOnboardingCompleted()) {
    return <Navigate to="/onboarding" />;
  }

  return children;
};

export default ProtectedRoutes;